export default function Button({ loading = false, loadingText = 'Cargando...', children, ...rest }) {
  return (
      <button
          className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
          {...rest}>
        {
          loading
              ?
              <>
                <span
                    className="animate-spin inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-white rounded-full"
                    role="status" aria-label="loading"/>
                {loadingText}
              </>
              :
              children
        }
      </button>
  )
}